class ProductFormQuantity extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const button = event.target.closest("button");

      if (!button) {
        return;
      }

      const new_value = Number(this.elements.input.value) + Number(button.dataset.value);

      if (new_value > 1) {
        this.elements.buttons.forEach((element) => {
          element.disabled = false;
        });
      }

      if (new_value == 1) {
        this.elements.buttons[0].disabled = true;
      }

      this.elements.input.value = new_value;
    });
  }

  get elements() {
    return {
      buttons: this.querySelectorAll("button"),
      input: this.querySelector("input")
    }
  }
}

customElements.define("product-form-quantity", ProductFormQuantity);
